(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ch-desk-shuffle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('desk-shuffle')) {
    class DeskShuffle extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        const dataNode = this.querySelector('[data-desk-products]');
        const products = JSON.parse(dataNode?.textContent || '[]');
        if (!products.length) return;

        const button = this.querySelector('[data-roll-button]');
        const buttonLabel = this.querySelector('[data-roll-button-label]');
        const image = this.querySelector('[data-roll-image]');
        const title = this.querySelector('[data-roll-title]');
        const price = this.querySelector('[data-roll-price]');
        const link = this.querySelector('[data-roll-link]');
        const index = this.querySelector('[data-roll-index]');
        const status = this.querySelector('[data-roll-status]');
        const originalButtonLabel = buttonLabel.textContent;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let current = -1;
        let busy = false;

        const render = (productIndex) => {
          current = productIndex;
          const product = products[productIndex];
          image.src = product.image;
          image.alt = product.imageAlt;
          title.textContent = product.title;
          price.textContent = product.price;
          link.href = product.url;
          index.textContent = `${String(productIndex + 1).padStart(2, '0')} / ${String(products.length).padStart(2, '0')}`;
        };

        const randomIndex = () => {
          if (products.length < 2) return 0;
          let next = Math.floor(Math.random() * products.length);
          if (next === current) next = (next + 1) % products.length;
          return next;
        };

        render(0);
        status.textContent = this.dataset.idle || status.textContent;

        button.addEventListener('click', () => {
          if (busy) return;
          busy = true;
          button.disabled = true;
          this.classList.add('is-rolling');
          buttonLabel.textContent = 'Rolling…';
          status.textContent = 'Shuffling the lineup';

          if (reducedMotion) {
            render(randomIndex());
          } else {
            let tick = 0;
            const timer = window.setInterval(() => {
              render(Math.floor(Math.random() * products.length));
              tick += 1;
              if (tick >= 8) {
                window.clearInterval(timer);
                render(randomIndex());
                status.textContent = 'This one picked you';
                this.classList.remove('is-rolling');
                button.disabled = false;
                buttonLabel.textContent = 'Roll again';
                busy = false;
              }
            }, 75);
          }

          if (reducedMotion) {
            status.textContent = 'This one picked you';
            button.disabled = false;
            buttonLabel.textContent = 'Roll again';
            busy = false;
          }
        });
      }
    }

    customElements.define('desk-shuffle', DeskShuffle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
